import dashboard from "./dashboard";
import users from "./users";
import tools from "./tools";
import { NavItemType } from "shared/types";


const menuItems: { items: NavItemType[] } = {
  items: [dashboard, users, tools],
};

export default menuItems;
